<template>
  <div class="input-root" :style="getRootStyle">
    <div
      :class="['form-label label-text', { 'label-text-filter': small }]"
      v-if="label"
    >
      {{ $t(label) }}
      <span v-if="is_required" class="req-sign">*</span>
    </div>

    <div
      class="form-control disabled"
      :style="cus_style"
      v-if="(disabled || readOnly) && type === 'number'"
    >
      {{ !isNaN(inputfield) && !isNaN(parseFloat(inputfield)) ? inputfield : $t(placeholder) }}
    </div>
    <div
      class="form-control disabled"
      :style="cus_style"
      v-else-if="(disabled || readOnly) && type !== 'password'"
    >
      {{ inputfield || $t(placeholder) }}
    </div>
    <b-form-input
      v-else-if="(disabled || readOnly) && type === 'password'"
      class="form-control disabled"
      :style="cus_style"
      :type="type"
      :disabled="true"
      :readonly="true"
      :value="inputfield"
      :placeholder="$t(placeholder)"
    />
    <validation-provider
      v-else
      :name="$t(name)"
      :rules="rules"
      :vid="vid"
      v-slot="{ errors }"
      slim
    >
      <b-form-input
        :class="[
          'form-control',
          {
            'invalid-input':
              is_invalid || (errors && errors.length) ? true : false,
          },
        ]"
        lazy-formatter
        :formatter="formatter"
        :parser="parser"
        :min="min"
        :max="max"
        :type="type"
        :label="label"
        :disabled="disabled ? true : false"
        :placeholder="$t(placeholder)"
        v-model.trim="inputfield"
        :style="cus_style"
        :readonly="readOnly"
        :small="small"
        :id="id"
        :ref="cus_ref"
        @keydown.enter="$emit('enter')"
        @click="$emit('click')"
        @keypress="keypress"
        :step="type === 'number' ? 'any' : ''"
        autocomplete="off"
      />
      <div class="helper-text" :style="helper_text_style" v-if="helper_text">
        {{ $t(helper_text) }}
      </div>
      <div class="helper-text" :style="helper_text_style" v-if="helper_text_hidden_in_error && errors && errors.length === 0">
        {{ $t(helper_text_hidden_in_error) }}
      </div>
      <div
        class="error-text"
        :style="helper_text_style"
        v-if="errors && errors.length"
      >
        {{ errors[0] }}
      </div>
      <slot name="attachment"></slot>
    </validation-provider>
  </div>
</template>

<script>
export default {
  emits: ["change-value", "change"],
  props: [
    "type",
    "label",
    "placeholder",
    "is_invalid",
    "helper_text",
    "helper_text_hidden_in_error",
    "helper_text_style",
    "field",
    "value",
    "cus_style",
    "remove_default_margin",
    "readOnly",
    "disabled",
    "cus_ref",
    "is_required",
    "small",
    "rules",
    "name",
    "click",
    "min",
    "max",
    "formatter",
    "parser",
    "id",
    "vid",
  ],
  data() {
    return { inputfield: this.value };
  },
  watch: {
    value: function (val) {
      if (this.type !== "file") this.inputfield = val;
    },
    inputfield() {
      this.$emit("change-value", this.inputfield, this.field);
      this.$emit("change");
    },
  },
  methods: {
    keypress(e) {
      if (this.type === "number" && (e.keyCode === 43 || e.keyCode === 45))
        e.preventDefault();
    },
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${
        this.remove_default_margin ? "0px" : "20px"
      };position:relative;`;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 14px;
  color: var(--color-61);
  margin-bottom: 5px;
  font-weight: 700;
}
.label-text-filter {
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--color-76);
}

.invalid-input {
  border-color: var(--color-47) !important;
  background-color: var(--color-01) !important;
}
.form-control {
  width: 100%;
  min-height: 40px;
  font-size: 14px;
  padding: 10px;
  background: var(--color-01);
  color: var(--color-61);
  border: 1px solid;
  border-radius: 6px;
  border-color: var(--color-64);
  box-shadow: 0px 1px 2px var(--color-37);
  font-weight: 400;

  &:focus-visible {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:hover {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:focus {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:disabled {
    background-color: var(--color-67);
  }
  &.disabled {
    overflow-wrap: break-word;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
